module.exports = __webpack_public_path__ + "img/header_6.1976722c.jpg";